<template>
	<StandardModal
		open
		small
		:title="$t('settings_apitokens_revoke_token_title')"
		@cancel="$emit('cancel')"
	>
		<div class="revoke-modal">
			<TrashCanIcon class="danger trash-logo" halo />
			<div class="token-name" v-text="token.name" />
			<div class="help" v-text="$t('settings_apitokens_revoke_token_help')" />
		</div>
		<template #confirm>
			<Button danger @click="revoke" :loading="processing">
				{{ $t('settings_apitokens_revoke') }}
			</Button>
		</template>
	</StandardModal>
</template>

<script>
import { revokeToken } from './apitokens'
import { TrashCanIcon } from '@/icons'
import SpinnerOverlay from '@/components/SpinnerOverlay'
import { StandardModal, Button } from '@/components/common'

export default {
	components: { TrashCanIcon, SpinnerOverlay, StandardModal, Button },

	props: ['token'],

	data() {
		return {
			processing: false,
		}
	},

	emits: ['cancel'],

	methods: {
		async revoke() {
			this.processing = true
			const { ok } = await revokeToken(this.token.id)
			if (!ok) {
				this.$alert.error()
				this.processing = false
				return
			}
			this.processing = false
			this.$emit('cancel')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.revoke-modal {
	display: flex;
	flex-direction: column;
	align-items: center;

	.token-name {
		font-family: Avenir-Heavy;
		font-size: 22px;
		margin-bottom: 16px;
		max-width: 445px;
		@include clamp(1);
	}

	.trash-logo {
		margin: 10px 0 5px;
		font-size: 58px;
		color: var(--red-200);
	}

	.help {
		font-family: 'Avenir-Medium';
		font-size: 18px;
		color: var(--neutral-600);
		max-width: 445px;
		text-align: center;
	}
}
</style>
